"use client";

import { createContext, useContext } from "react";

function adminHref(path: string) {
  if (path === "/drills") return "/admin";
  if (path.startsWith("/drills/collections/")) {
    const rest = path.slice("/drills/collections/".length);
    const split = rest.indexOf("?");
    const id = split < 0 ? rest : rest.slice(0, split);
    const query = split < 0 ? "" : rest.slice(split);
    return `/admin/drill-collections/${id}${id === "new" ? "" : "/content"}${query}`;
  }
  if (
    path.startsWith("/drills/") ||
    path === "/layouts" ||
    path.startsWith("/layouts/")
  )
    return `/admin${path}`;
  if (path === "/login" || path === "/account") return "/admin/login";
  return path;
}

const playerScope = {
  admin: false,
  href: (path: string) => path,
  api: (path: string) => path,
  draftPrefix: "tamariba.drill-layout-draft:",
};
const adminScope = {
  admin: true,
  href: adminHref,
  api: (path: string) => path.replace(/^\/api\//, "/api/admin/"),
  draftPrefix: "tamariba.admin.drill-layout-draft:",
};
const AuthoringScope = createContext(playerScope);

export function AdminAuthoringScope({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthoringScope.Provider value={adminScope}>
      {children}
    </AuthoringScope.Provider>
  );
}

export function useAuthoringScope() {
  return useContext(AuthoringScope);
}
